module.exports = __webpack_public_path__ + "img/11.1f5e3892.jpg";